'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

var _cookies = document.cookie;
var closed_bar = 'bar=;';

var cookie_expires_date = new Date();
cookie_expires_date.setDate(cookie_expires_date.getDate() + 3);

//sticky head
(0, _jquery2.default)(window).on('load scroll resize', function () {
	topBarToggle();
});

if (_cookies.indexOf('bar=;') > -1) {
	(0, _jquery2.default)('.js-top-bar').addClass('top-bar-closed').hide();
	(0, _jquery2.default)('body').addClass('disable-top-bar');
}

(0, _jquery2.default)('.js-close-top-bar').on('click', function (e) {
	e.preventDefault();

	document.cookie = 'bar=; expires=' + cookie_expires_date + '; path=/; ';

	(0, _jquery2.default)('body').addClass('disable-top-bar');
	(0, _jquery2.default)('.js-top-bar').slideUp().addClass('top-bar-closed');
});

function topBarToggle() {
	var $topBar = (0, _jquery2.default)('.js-top-bar');
	var $header = (0, _jquery2.default)('.header');

	if (!(0, _jquery2.default)('body').hasClass('disable-top-bar')) {
		if ($header.hasClass('header-is-fixed')) {
			(0, _jquery2.default)('body').addClass('has-header-bar');
			$topBar.slideUp();
			$topBar.addClass('sliding-up');
			$header.addClass('delay-color-transition');

			setTimeout(function () {
				$header.removeClass('delay-color-transition');
			}, 800);

			setTimeout(function () {
				if ((0, _jquery2.default)('body, html').hasClass('expand-search')) {
					(0, _jquery2.default)('.js-trigger-srch-field').trigger('click');
				}
			}, 500);
		} else {
			(0, _jquery2.default)('body').removeClass('has-header-bar');
			$topBar.slideDown();
			$topBar.removeClass('sliding-up');
			$header.removeClass('delay-color-transition');
		}
	}
}